export class BankSlipModel {

  urlBoleto: string;

  ReceiverId: string;
  ReferenceId: string;
  OwnerId: string;
  OwnerName: string;
  OwnerDocumentType: number;
  OwnerDocument: string;
  OwnerEmail: string;
  Amount: number;

  CartaoCashlessTag: string;
  Valor: number;

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/models/bankslip.model.ts